import { render, staticRenderFns } from "./sinp_eoi.vue?vue&type=template&id=68c2b440&"
import script from "./sinp_eoi.vue?vue&type=script&lang=js&"
export * from "./sinp_eoi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports